import React, { useState ,useEffect} from "react";
import { makeStyles } from "@material-ui/core/styles";

import Grid from "@material-ui/core/Grid";

import UserTable from "./UserTable";
import { Button, Paper, TextField } from "@material-ui/core";
import Spacer from "../../components/Spacer";
import MainContainer from "../../components/MainContainer";
import { headerDataAdmin } from "../../data/modules/admin-header";
import { userDetailContext } from "../../App";
import { useContext } from "react";
import { hasPrivilege } from "../../utils/privilege";
import { useNavigate } from "react-router-dom";
import SearchIcon from '@mui/icons-material/Search';
import DirectionService from "../../services/DirectionService";
import * as XLSX from 'xlsx';
import CircularProgress from '@mui/material/CircularProgress';
import { saveAs } from 'file-saver';
import {
  FormControl,
  Select,
  MenuItem,
  InputLabel
} from "@material-ui/core";
import PlanningService from "../../services/PlanningService";
import UserService from "../../services/UserService";
import ExcelJS from 'exceljs';


const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
    elevation: 0,
  },
}));

export default function UserList() {
  const navigate = useNavigate();

  const classes = useStyles();
  const contextData = useContext(userDetailContext);
  const[direction,setDirection]=useState([]);
  const [service,setService]=useState([]);
  const [form, setForm] = useState({
      direction_id: localStorage.getItem("USER_DIR"),
      service_id: 0,
      type:"all"
  });
  const [filters, setFilters] = useState({
    direction_id: localStorage.getItem("USER_DIR"),
    service_id: 0,
    type:"all"
  });
  const iddiruser=localStorage.getItem("USER_DIR");
  const [idservice, setIdservice] = useState(0);
  const [iddir, setIddir] = useState(0);
  const [loading, setLoading] = useState(false);
  function handleClick() {
    navigate("/users/add");
  }


    const handleexportexcel = async () => {
      setLoading(true);

      try {
          // Récupérer les données
          const result = await UserService.getAllUserlist(filters.direction_id, filters.service_id,filters.type);
          if (!result?.data) return;

          const users = result.data;

          // Créer un nouveau workbook
          const workbook = new ExcelJS.Workbook();
          const worksheet = workbook.addWorksheet('Liste du personnel');

          // Définir les colonnes avec leurs en-têtes
          worksheet.columns = [
              { header: 'ID', key: 'id', width: 10 },
              { header: 'Matricule', key: 'registration_number', width: 15 },
              { header: 'Direction', key: 'direction', width: 20 },
              { header: 'Service', key: 'service', width: 20 },
              { header: 'Fonction', key: 'function_name', width: 20 },
              { header: 'Nom', key: 'last_name', width: 20 },
              { header: 'Prénom', key: 'first_name', width: 20 },
              { header: 'Sexe', key: 'sex', width: 20 },
              { header: 'Email', key: 'email', width: 25 },
              { header: 'Téléphone', key: 'telephone', width: 15 },
              { header: 'Financement', key: 'funding', width: 15 }
          ];

          // Fonction utilitaire pour nettoyer les espaces
          const cleanString = (value) => {
              if (typeof value === 'string') {
                  return value.trim().replace(/\s+/g, ' ');
              }
              return value;
          };

          // Fonction pour formater le sexe
          const formatSex = (sexId) => {
              if (sexId === "2") {
                  return 'Femme';
              }
              return 'Homme';
          };

          // Ajouter les données avec nettoyage
          users.forEach(user => {
              worksheet.addRow({
                  id: user.user_id || '', // Ajout de l'ID qui prend la valeur user_id
                  registration_number: cleanString(user.registration_number) || '',
                  direction: cleanString(user.direction) || '',
                  service: cleanString(user.service) || '',
                  function_name: cleanString(user.function_name) || '',
                  last_name: cleanString(user.last_name) || '',
                  first_name: cleanString(user.first_name) || '',
                  sex: formatSex(user.sex_id), // Correction du sexe
                  email: cleanString(user.email) || '',
                  telephone: cleanString(user.telephone) || '',
                  funding: cleanString(user.funding) || ''
              });
          });

          // Appliquer le style aux en-têtes
          const headerRow = worksheet.getRow(1);
          headerRow.eachCell((cell) => {
              cell.fill = {
                  type: 'pattern',
                  pattern: 'solid',
                  fgColor: { argb: 'FFD9E1F2' }
              };
              cell.font = {
                  bold: true,
                  color: { argb: 'FF000000' } 
              };
              cell.alignment = { 
                  horizontal: 'center',
                  vertical: 'middle'
              };
              cell.border = {
                  top: { style: 'thin' },
                  left: { style: 'thin' },
                  bottom: { style: 'thin' },
                  right: { style: 'thin' }
              };
          });

          // Appliquer le style aux cellules de données
          worksheet.eachRow((row, rowNumber) => {
              if (rowNumber > 1) { // Ignorer l'en-tête
                  row.eachCell((cell) => {
                      cell.alignment = {
                          horizontal: 'left',
                          vertical: 'middle'
                      };
                      cell.border = {
                          top: { style: 'thin' },
                          left: { style: 'thin' },
                          bottom: { style: 'thin' },
                          right: { style: 'thin' }
                      };
                  });
              }
          });

          // Ajuster la hauteur des lignes
          worksheet.getRow(1).height = 25;
          
          // Figer la première ligne (en-tête)
          worksheet.views = [
              { state: 'frozen', xSplit: 0, ySplit: 1 }
          ];

          // Générer le fichier Excel
          const buffer = await workbook.xlsx.writeBuffer();

          // Télécharger le fichier avec date
          const now = new Date();
          const fileName = `list_personnel_${now.getFullYear()}-${(now.getMonth() + 1).toString().padStart(2, '0')}-${now.getDate().toString().padStart(2, '0')}.xlsx`;

          const blob = new Blob([buffer], { 
              type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
          });
          saveAs(blob, fileName);

      } catch (error) {
          console.error("Erreur lors de l'export :", error);
      } finally {
          setLoading(false);
      }
  };

  function handleChangeDirection(event) {
    const { name, value } = event.target;
    setForm({ ...form, [name]: value });
    setIddir(value);
  }

  function handleChangeService(ev) {
    const { name, value } = ev.target;
    setForm({ ...form, [name]: value });
    setIdservice(value);
  }

  function handleChangeType(ev) {
    const { name, value } = ev.target;
    setForm({ ...form, [name]: value });
  }

  useEffect(() => {
      setIddir(localStorage.getItem("USER_DIR"));
      DirectionService.getDirection().then((res) => {
        if (res && res.status) {
          setDirection(res.data);
        }
      });
  
  }, []);

    useEffect(() => {
      if (iddir !== 0 && iddir !== "") {
        PlanningService.Direction(iddir).then((results) => {
          if (results && results.data) {
            setService(results.data);
          }
        })

      }
    }, [iddir]);

    const handleSubmit = () => {
      setFilters({
        direction_id: form.direction_id,
        service_id: form.service_id,
        type:form.type
      });
   };

  return (
    <MainContainer {...headerDataAdmin}>
      <Grid container item xs={12}>
        {hasPrivilege(contextData.privileges, 'Admin-Button-Import-User') &&
          <Button
            variant="contained"
            onClick={handleClick}
            style={{ fontWeight: 800 ,width:170 }}
          >
            {" "}
          Importer
        </Button>
        }
        <Spacer x={2} />
           <Button
              variant="contained"
              color="primary"
              onClick={handleSubmit}
              startIcon={<SearchIcon />}
              style={{ fontWeight: 800 ,width:170}}
           >
             Filtrer
          </Button>
        <Spacer x={2} />
         <Button
            variant="contained"
            onClick={handleexportexcel}
            style={{ fontWeight: 800, width: 170 }}
            disabled={loading}
          >
            {loading ? (
                <>
                  <CircularProgress size={24} color="inherit" /> Chargement....
                </>
              ) : (
                "Exporter"
              )}
          </Button>

        <Spacer x={2} />
        {hasPrivilege(contextData.privileges, 'Admin-User-Add') &&
          <Button
            variant="contained"
            color="secondary"
            onClick={handleClick}
            style={{ fontWeight: 600 }}
          >
            CREER
        </Button>
        }
        <Spacer x={2} />
      </Grid>
      <Spacer y={8}/>
      <Grid container spacing={3} justifyContent="center">
                      <Grid item xs={12} md={5} sm={4} lg={4}>
                        <FormControl fullWidth variant="outlined" size="small">
                          <InputLabel id="demo-simple-select-outlined-label">Direction</InputLabel>
                          <Select
                            labelId="demo-simple-select-outlined-label"
                            id="demo-simple-select-outlined"
                            label="Direction"
                            value={form.direction_id}
                            name="direction_id"
                            onChange={handleChangeDirection}
                            disabled={parseInt(iddiruser,10)!== 1} 
                          >
                            <MenuItem value={0}>Toutes</MenuItem>
                            {direction.map((row) => (
                              <MenuItem key={row.direction_id} value={row.direction_id}>
                                {row.code}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} md={5} sm={4} lg={4}>
                        <FormControl fullWidth variant="outlined" size="small">
                          <InputLabel id="demo-simple-select-outlined-label">Service</InputLabel>
                          <Select labelId="demo-simple-select-outlined-label" id="demo-simple-select-outlined" label="Service" value={form.service_id} name="service_id" onChange={handleChangeService} >
                            <MenuItem value={0}> Tous </MenuItem>
                            {service.map((row) => (
                              <MenuItem key="{row.service_id}" value={row.service_id}>{row.code}</MenuItem>
                            ))}
                          </Select>
                        </FormControl>
      
                      </Grid>
                      <Grid item xs={12} md={5} sm={4} lg={4}>
                         <FormControl fullWidth variant="outlined" size="small" required>
                                  <InputLabel>Type </InputLabel>
                                    <Select
                                        label="Type"
                                        name="type"
                                        value={form.type}
                                        onChange={handleChangeType} 
                                    >
                                    <MenuItem value="">
                                    <em>Veuillez sélectionner un type</em>
                                    </MenuItem>
                                        <MenuItem value="all">Tous</MenuItem>
                                        <MenuItem value="0">Cadre</MenuItem>
                                        <MenuItem value="2">Temporaire</MenuItem>
                                    </Select>
                          </FormControl>
                      </Grid>
                      
            </Grid>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Paper className={classes.paper} variant="outlined">
            <UserTable dir={filters.direction_id} idservice={filters.service_id} type={filters.type}/>
          </Paper>
        </Grid>
      </Grid>
    </MainContainer>
  );
}